/* @flow */
import * as ActionTypes from '../actions';

type State = {isFetching: boolean, logged: boolean};

const loginStatus = (state: State = { isFetching: false, logged: false }, action: any) => {
  switch (action.type) {
    case ActionTypes.LOGIN_REQUEST:
      return {
        ...state,
        ...action.loginData,
        isFetching: true,
        isFailure: false,
      };
    case ActionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        profile: action.response,
        rememberMe: ('loginData' in action ? action.loginData.rememberMe | 0 : false),
        logged: true,
        isFailure: false,
        isFetching: false
      };
    case ActionTypes.LOGIN_FAILURE:
      return {
        ...state,
        logged: false,
        isFailure: true,
        isFetching: false
      };
    default:
      return state;
  }
};

export default loginStatus;



/** WEBPACK FOOTER **
 ** ./src/reducers/loginStatus.js
 **/